import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "deal-document-types";

export const GET_DEAL_DOCUMENT_TYPES = "getDealDocumentTypes";
export const GET_DEAL_DOCUMENT_TYPE = "getDealDocumentType";
export const GET_DEAL_DOCUMENT_TYPE_OPTIONS = "getDealDocumentTypeOptions";
export const STORE_DEAL_DOCUMENT_TYPE = "storeDealDocumentType";
export const UPDATE_DEAL_DOCUMENT_TYPE = "updateDealDocumentType";
export const DELETE_DEAL_DOCUMENT_TYPE = "deleteDealDocumentType";

const actions = {
  [GET_DEAL_DOCUMENT_TYPES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_DEAL_DOCUMENT_TYPE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_DEAL_DOCUMENT_TYPE_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, "options")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [STORE_DEAL_DOCUMENT_TYPE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [UPDATE_DEAL_DOCUMENT_TYPE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, params.id, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [DELETE_DEAL_DOCUMENT_TYPE](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

export default {
  actions,
};
